import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  page: number;
  limit: number;
  search: string;
  fromDate: string | undefined;
  toDate: string | undefined;
  type?: string;
  status?: string;
}

export const useGetTransactionLogs = ({
  page,
  limit,
  search,
  fromDate,
  toDate,
  type,
  status,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [
      ENDPOINTS.GET_TRANSACTION_LOGS,
      {
        page: page,
        limit: limit,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
        type: type || undefined,
        status: status || undefined,
      },
    ],
    {
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
